
export const appHeaderTestProps = {
  hideSearchBoolean: false,
  useMinifiedHeaderBoolean: false,
  isUnitedStates: false,
  isTaiwan: false,
  isEuBd: true,
  businessDirectoryLocalized: "Firmenverzeichnis"
}
